import type { HealthDto, LivenessDto, RootDto } from './dto'
import type { ApiContext } from './http'
import { request } from './http'
import { mapHealth } from './mappers'
import type { ServiceHealth } from './models'

/** Short ceiling — a health probe that hangs is already a failed probe. */
const HEALTH_TIMEOUT_MS = 6000

export function fetchHealth(
  context: ApiContext,
  signal?: AbortSignal,
): Promise<ServiceHealth> {
  return request<HealthDto>(context, {
    path: '/health',
    timeoutMs: HEALTH_TIMEOUT_MS,
    ...(signal ? { signal } : {}),
  }).then(mapHealth)
}

export function fetchLiveness(
  context: ApiContext,
  signal?: AbortSignal,
): Promise<LivenessDto> {
  return request<LivenessDto>(context, {
    path: '/health/live',
    timeoutMs: HEALTH_TIMEOUT_MS,
    ...(signal ? { signal } : {}),
  })
}

export function fetchReadiness(
  context: ApiContext,
  signal?: AbortSignal,
): Promise<LivenessDto> {
  return request<LivenessDto>(context, {
    path: '/health/ready',
    timeoutMs: HEALTH_TIMEOUT_MS,
    ...(signal ? { signal } : {}),
  })
}

export function fetchRoot(
  context: ApiContext,
  signal?: AbortSignal,
): Promise<RootDto> {
  return request<RootDto>(context, {
    path: '/',
    timeoutMs: HEALTH_TIMEOUT_MS,
    ...(signal ? { signal } : {}),
  })
}
